import React, { useEffect, useState } from 'react';

import { toJS } from 'mobx';
import { cloneDeep } from 'lodash';
import { LinearProgress } from '@mui/material';
import { observer } from 'mobx-react';
import moCompanyDistribution from './store';

interface IProps { }
interface IState { }

const MapTopRanking = (props: IProps, state: IState) => {
  const [active, setActive] = useState<number>(-1);
  const { distributList, mouseCtive } = moCompanyDistribution;

  const getArrayIndex = (arr: any, value: any) => {
    // let i = arr.length;
    let index = -1;
    for (let i = 0; i < arr.length; i += 1) {
      if (arr[i].city === value) index = i;
    }
    return index;
  };

  useEffect(() => {
    setActive(getArrayIndex(distributList, mouseCtive));
  }, [mouseCtive, distributList]);

  const getMax = () => {
    const result = cloneDeep(distributList);
    if (result.length > 0) {
      const list = result?.sort((a, b) => b.amount - a.amount);
      return list[0].amount;
    }
    return 1000;
  };

  const normalise = (value: any) => ((value * 100) / getMax());

  return (
    <section className="company-ranks-warps">
      <span className="sub-title01">排行</span>
      <p>单位(公司数)</p>
      {
        distributList?.slice(0, 10).map((item: any, i) => (
          <section
            className={active !== i ? 'map-top-ranking-content-005' : 'map-top-ranking-content-008'}
            key={i.toString()}
            onMouseEnter={() => setActive(i)}
            onMouseLeave={() => setActive(-1)}>
            <span className="map-item-008">
              {item.city || item.city_grade || item.city_region}
            </span>
            <p className="map-top-progress-001" style={{ width: '120px' }}>
              <LinearProgress variant="buffer"
                value={normalise(item.amount)}
                valueBuffer={0} />
            </p>
            <span className="up-item-009">{Number(item.amount).toLocaleString()}</span>
          </section>
        ))
      }
    </section >
  );
};

export default observer(MapTopRanking);
